import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";


export const getSubCategoriasFinanzas = async () => {

    const result = await PrivateInterceptor(`Base/Global/SubCategoriasFinanzas`, 'GET');
    return result;

}

export const postSubCategoriasFinanzas = async (datos) =>{
    
    const result = await PrivateInterceptor(`Base/Global/SubCategoriasFinanzas`, 'POST', datos);
    return result;
}


export const getInfoSubCategoria = async (IdSubCategoriaFinanzas) => {

    const result = await PrivateInterceptor(`Base/Global/SubCategoriasFinanzas/${IdSubCategoriaFinanzas}`, 'GET');
    return result;

}

export const getInventarioSubCategoria = async (dates, IdSubCategoria) =>{

    const result = await PrivateInterceptor(`Base/Global/SubCategoriasFinanzas/InventarioSubCategoria`, 'POST', {FechaInicio :dates[0], FechaFinal: dates[1], IdSubCategoria: IdSubCategoria} );
    return result;

}

export const putEstadoSubCategoria = async(datosEnviar) => {

    const result = await PrivateInterceptor(`Base/Global/SubCategoriasFinanzas/Estado`, 'PUT', datosEnviar);
    return result;
}